module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-hover-big.f87bf190.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-hover-big.png
// module id = 2647
// module chunks = 11